import axios from "axios";

import moment from "moment";
moment.locale("es");

export default class MailService {
  constructor() {}
}



// WEBPACK FOOTER //
// ./components/Header/data.js